module.exports = __webpack_public_path__ + "static/media/icon-track-assignment-summary.1b9e699a.svg";